import axios from "axios";

export function getEventStudentMessageStatus() {
  return axios.get(
    process.env.VUE_APP_API_URL + "EventStudentMessageStatus/getlist"
  );
}

export function postEventStudentMessageStatus(data) {
  return axios.post(
    process.env.VUE_APP_API_URL + "EventStudentMessageStatus/add",
    data
  );
}

export function updateEventStudentMessageStatus(data) {
  return axios.put(
    process.env.VUE_APP_API_URL + "EventStudentMessageStatus/update",
    data
  );
}

export function deleteEventStudentMessageStatus(eventStudentMessageStatusId) {
  const config = {
    params: {
      eventStudentMessageStatusId: eventStudentMessageStatusId,
    },
  };

  return axios.delete(
    process.env.VUE_APP_API_URL + "EventStudentMessageStatus/deleted",
    config
  );
}
